import React from 'react'

const WizardViewMoreButton = ({
  expanded,
  label,
  onClick,
  className,
}) => {
  return (
    <button className={`wizard-view-more-button ${className}`} onClick={onClick}>
      {expanded ? (
        <>
          <i className="ri-arrow-up-s-line" />
          {label}
        </>
      ) : (
        <>
          <i className="ri-arrow-down-s-line" />
          {label}
        </>
      )}
    </button>
  )
}

export default WizardViewMoreButton
